import React, { Component } from 'react';
import TokenStore from '../lib/token_store.js';

class PendingVerification extends Component {
  componentDidMount(){
    this.refreshToken()
  }

  componentWillUnmount() {
    this.cancelTimer = true
    clearInterval(this.refreshTimer);
  }

  refreshToken(){
    console.log("refreshing token")
    const self = this;
    TokenStore.renew().then(() => {
      if (!self.cancelTimer) {
        self.refreshTimer = setTimeout(() => { this.refreshToken() }, 2500)
      }
    })
  }


  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Pending Verification</h2>
          <p className="lead">Go check your emails.</p>
        </div>
      </LayoutWrapper>
    );
  }
}

export default PendingVerification;



// WEBPACK FOOTER //
// ./src/pages/pending_verification.js